/**
 * Created by felixmorenomartinez on 16/02/14.
 * Ported to ES6 on 16/10/2016
 */

export default class CameraControl {

    constructor( camera, target, domElement ){

        this.PI = 3.14159265359;
        this.camera = camera;
        this.target = target;
        this.displacement = { x : 0, y : 0 };
        this.prevAngles = { 
            x : -0.1422115, 
            y : 0.0749
        };
        this.currentAngles = { 
            x : this.prevAngles.x, 
            y : this.prevAngles.y
        };
        this.finalRadians = { 
            x : this.prevAngles.x  * (this.PI * 2), 
            y : this.prevAngles.y * (this.PI * 2) 
        };
        this.downPoint = { x : 0, y : 0 };
        this.down = false;
        
        this.radius = 1200;
        this.wheelDelta = 1200;
        this.limits = { up : 0.2, down : 0.05 };
        this.mouseX = -1;
        this.mouseY= -1;
        this._mouseX = -1;
        this._mouseY= -1;
        this.onMove = null;
        this.enabled = true;

        this.domElement = domElement;

        this.events();

    }

    events(){
        let domElement = this.domElement || window;
        let mouseWheelEvent = (/Firefox/i.test(navigator.userAgent))? "DOMMouseScroll" : "mousewheel";

        this.mouseWheelHandler = this.onMouseWheel.bind( this );
        this.mouseDownHandler = this.onMouseDown.bind( this );
        this.mouseUpHandler = this.onMouseUp.bind( this );
        this.mouseMoveHandler = this.onMouseMove.bind( this );

        this.touchStartHandler = this.onTouchStart.bind( this );
        this.touchEndHandler = this.onTouchEnd.bind( this );
        this.touchMoveHandler = this.onTouchMove.bind( this );

        document.addEventListener( mouseWheelEvent, this.mouseWheelHandler, { passive: false } );
        domElement.addEventListener( 'mousedown',  this.mouseDownHandler );
        domElement.addEventListener( 'mouseup', this.mouseUpHandler );
        domElement.addEventListener( 'mousemove', this.mouseMoveHandler );

        domElement.addEventListener('touchstart', this.touchStartHandler );
        domElement.addEventListener('touchend', this.touchEndHandler );
        domElement.addEventListener('touchmove',  this.touchMoveHandler );
    }

    removeEvents(){
        let domElement = document.getElementById('scrollHandler') || window;
        let mouseWheelEvent = (/Firefox/i.test(navigator.userAgent))? "DOMMouseScroll" : "mousewheel";

        document.removeEventListener( mouseWheelEvent, this.mouseWheelHandler, { passive: false } );
        domElement.removeEventListener( 'mousedown',  this.mouseDownHandler );
        domElement.removeEventListener( 'mouseup', this.mouseUpHandler );
        domElement.removeEventListener( 'mousemove', this.mouseMoveHandler );

        domElement.removeEventListener('touchstart', this.touchStartHandler );
        domElement.removeEventListener('touchend', this.touchEndHandler );
        domElement.removeEventListener('touchmove',  this.touchMoveHandler );

    }

    onTouchStart( e ){
        if (this.enabled) {
            e.preventDefault();
        }
        let ev = { pageX : e.changedTouches[0].pageX, pageY: e.changedTouches[0].pageY };
        ev.preventDefault = function(){};
        this.onMouseDown( ev );
        this.touch = true;

    }

    onTouchEnd( e ){
        if (this.enabled) {
            e.preventDefault();
        }
        let ev = { pageX : e.changedTouches[0].pageX, pageY: e.changedTouches[0].pageY };
        ev.preventDefault = function(){};
        this.onMouseUp( ev );
        this.touch = false;

    }

    onTouchMove( e ){
        if (this.enabled) {
            e.preventDefault();
        }
        let ev = { pageX : e.changedTouches[ 0 ].pageX, pageY: e.changedTouches[0].pageY };
        ev.preventDefault = function(){};
        this.onMouseMove( ev );

    }

    onMouseWheel(e) {
        if (this.enabled) {
            e.preventDefault();
        }
        let delta = e.detail ? e.detail * -120 : e.wheelDelta;
        this.wheelDelta -= delta * 0.1;

        this._mouseX = e.pageX;
        this._mouseY = e.pageY;
        this.mouseX = e.pageX;
        this.mouseY = e.pageY;
    }

    onMouseDown(e) {
        if (this.enabled) {
            e.preventDefault();
        }
        this.down = true;

        this.downPoint.x = e.pageX;
        this.downPoint.y = e.pageY;
    }

    onMouseUp(e) {
        if (this.enabled) {
            e.preventDefault();
        }
        this.down = false;

        this.prevAngles.x = this.currentAngles.x;
        this.prevAngles.y = this.currentAngles.y;

        this._mouseX = e.pageX;
        this._mouseY = e.pageY;
        this.mouseX = e.pageX;
        this.mouseY = e.pageY;
    }

    onMouseMove(e) {
        if (this.enabled) {
            e.preventDefault();
        }
        if( this.down && !window.noUpdateCamera ) {
            this.displacement.x = ( this.downPoint.x - e.pageX ) / window.innerWidth;
            this.displacement.y = ( this.downPoint.y - e.pageY ) / window.innerHeight;

            this.currentAngles.x = ( this.prevAngles.x + this.displacement.x );
            this.currentAngles.y = ( this.prevAngles.y - this.displacement.y );

            if( Math.abs(this.displacement.x) > 0.001 || Math.abs(this.displacement.x) > 0.001) this.moving = true;

            //Check if outside limits
            if( this.currentAngles.y > this.limits.up ) {
                this.currentAngles.y = this.prevAngles.y = this.limits.up;
                this.downPoint.y = e.pageY;
            }

            if( this.currentAngles.y < this.limits.down ) {
                this.currentAngles.y = this.prevAngles.y = this.limits.down;
                this.downPoint.y = e.pageY;
            }

        } else {
            this._mouseX = e.pageX;
            this._mouseY = e.pageY;
        }

        if( this.onMove) this.onMove();

    }

    update( t ) {
        // Interpolamos los radianes en x y en y
        this.finalRadians.x += ( this.currentAngles.x * this.PI * 2 - this.finalRadians.x ) / 20;
        this.finalRadians.y += ( this.currentAngles.y * this.PI * 2 - this.finalRadians.y ) / 50;

        // console.log(this.currentAngles, this.radius)
        this.radius += ( this.wheelDelta - this.radius ) / 20;

        this.camera.position.set(
            this.target.x + ( Math.sin( this.finalRadians.x ) * Math.cos( this.finalRadians.y ) * this.radius ),
            this.target.y + ( Math.sin( this.finalRadians.y ) * this.radius ),
            this.target.z + ( Math.cos( this.finalRadians.x ) * Math.cos( this.finalRadians.y ) * this.radius )
        );

        this.camera.lookAt(this.target);

        this.mouseX += (this._mouseX - this.mouseX) / 10;
        this.mouseY += (this._mouseY - this.mouseY) / 10;
    }

    dispose(){
        this.removeEvents();
    }

}
